import React from "react";
import "./FormDetailsTable.scss";

const FormDetailsTable = ({ formDetails, thirdCol, tabName, onChangeRadio, error }) => {

  // Define which audit detail fields should NOT have correction options (red box fields)
  const nonEditableAuditFields = [
    "Will this be done in Conjunction with FSSC Certification Audit",
    "Audit Criteria (Applicable Standard or Technical Specifications)",
    "Audit Type",
    "Version",
    "Audit Focus Area"
  ];

  const isFieldEditable = (fieldLabel) => {
    return !nonEditableAuditFields.some(nonEditable => 
      fieldLabel.toLowerCase().includes(nonEditable.toLowerCase())
    );
  };

  return (
    <>
      {Object.keys(formDetails).length > 0 && (
        <div
          className={`form-details-table-container ${
            thirdCol ? "form-details-verification-container" : ""
          }`}
        >
          <table
            className={`form-details-table ${
              thirdCol ? "form-details-verification" : ""
            }`}
          >
            <thead>
              <tr>
                <th
                  style={{
                    width: `${thirdCol ? "33%" : "48%"}`,
                    borderRadius: "10px 0px 0px 0px",
                  }}
                >
                  Field
                </th>
                <th
                  style={{
                    width: `${thirdCol ? "33%" : "48%"}`,
                    borderRadius: "0px 10px 0px 0px",
                  }}
                >
                  Response
                </th>
                {thirdCol && (
                  <th
                    style={{
                      width: "33%",
                      borderRadius: "0px 10px 0px 0px",
                      textAlign: "center",
                    }}
                  >
                    Verification status
                  </th>
                )}
              </tr>
            </thead>
            {Object.keys(formDetails).length > 0 ? (
              <tbody>
                {tabName === "unitDetails" && (
                  <>
                    {formDetails?.unitDetails?.map((row, index) => (
                      <tr key={index}>
                        <td>{row.label}</td>
                        <td>{row.value ? row.value : "N/A"}</td>
                        {thirdCol && (
                          <td style={{ textAlign: "center" }}>Verified</td>
                        )}
                      </tr>
                    ))}
                    {formDetails?.offSiteFields?.map((row, index) => (
                      <tr key={index}>
                        <td>{row.label}</td>
                        <td>{row.value ? row.value : "N/A"}</td>
                        {thirdCol && (
                          <td style={{ textAlign: "center" }}>Verified</td>
                        )}
                      </tr>
                    ))}
                  </>
                )}
                {tabName === "auditDetails" && (
                  <>
                    {formDetails.map((row, index) => {
                      const isEditable = isFieldEditable(row.label);
                      return (
                        <tr key={index}>
                          <td style={{textTransform:"capitalize"}}>{row.label}</td>
                          <td style={{textTransform:"capitalize"}}>{row.value ? row.value : "N/A"}</td>
                          {thirdCol && (
                            <td style={{ textAlign: "center" }}>
                              {isEditable ? (
                                <div className="radio-group">
                                  <label>
                                    <input
                                      type="radio"
                                      name={`audit-${row.id}`}
                                      value="verified"
                                      checked={row.verificationStatus === "Verified"}
                                      onChange={() => onChangeRadio && onChangeRadio(row.id, row, "auditDetails", "verified", row.id)}
                                    />
                                    <span>Verified</span>
                                  </label>
                                  <label>
                                    <input
                                      type="radio"
                                      name={`audit-${row.id}`}
                                      value="correction"
                                      checked={row.verificationStatus === "Needs Correction"}
                                      onChange={() => onChangeRadio && onChangeRadio(row.id, row, "auditDetails", "correction", row.id)}
                                    />
                                    <span>Needs Correction</span>
                                  </label>
                                </div>
                              ) : (
                                <span style={{ color: "#666", fontStyle: "italic" }}>Verified</span>
                              )}
                            </td>
                          )}
                        </tr>
                      );
                    })}
                  </>
                )}
              </tbody>
            ) : (
              <tr>
                <td>No Data Available...</td>
              </tr>
            )}
          </table>
        </div>
      )}
    </>
  );
};

export default FormDetailsTable;
